import { openDialog } from 'src/services/jira';

import jira from 'src/lib/api/jira';

export const openSidebarVisibilityMigrationModal = ({ afterClose }) => {
  openDialog(`/integration-jira-ui/settings/modal/sidebar_visibility_migration`, {
    width: '50vw',
    onClose: () => {
      afterClose();
    }
  });
};

export const setSidebarVisibleByDefault = async (value) => {
  await jira.setSettings({ sidebarVisibleByDefault: { value } });
};
